/* eslint-disable @typescript-eslint/no-explicit-any */
import { zodResolver } from '@hookform/resolvers/zod';
import React, { Typography, Grid, Paper } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { UserService } from 'services';
import { z } from 'zod';
import { useRequestPasswordResetForm } from 'hooks';
import {
    SubmitButton,
    FormTextInput,
    ErrorDisplay
} from 'components';

export const RequestPasswordResetForm = () => {
    const { schema } = useRequestPasswordResetForm();
    type FormFields = z.infer<typeof schema>;
    const methods = useForm<FormFields>({
        resolver: zodResolver(schema),
        mode: 'onBlur',
    });
    const onSubmit = async (data: FormFields) => {
        try {
            await UserService.requestPasswordReset(data.email);
        } catch (e: any) {
            methods.setError('root', { type: 'manual', message: e.message });
        }
    };
    const onError = async (data: any) => {
        console.log(data);
    };
    return (<>
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit, onError)} style={{ width: '25%', height: '80%' }}>
                <Grid container justifyContent='center' textAlign={'center'} spacing={2} component={Paper} p={5}>
                    <Grid item xs={12}>
                        <img src='/logo.png' alt='Logo' style={{ width: 'auto', height: '132px', margin: 'auto' }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h4' gutterBottom>
                            Request password reset
                        </Typography>
                    </Grid>
                    <Grid item xs={12} textAlign={'center'}>
                        <FormTextInput name='email' />
                    </Grid>
                    <Grid item xs={12} textAlign={'start'}>
                        <ErrorDisplay message={methods.formState?.errors?.root?.message} />
                    </Grid>
                    <Grid item xs={8} textAlign={'center'}>
                        <SubmitButton text='Request Password reset' />
                    </Grid>
                </Grid>
            </form>
        </FormProvider>
    </>
    );
}